import { VehicleType, VersionedObjectDiff } from '@clearcover/core-app-types';
import React from 'react';
import {
  PolicyChangeCard,
  changeTypes,
  getCurrentData,
  joinNonEmpty,
} from '../PolicyChangeCard/PolicyChangeCard';
import { ChangeCardAndDetails } from '../PolicyChangeCard/types';
import { PolicyChangeVehicleDetails } from './PolicyChangeVehicleDetails';

export const toVehicleCardAndDetails = (
  diff: VersionedObjectDiff<VehicleType>,
  versionId: string
): ChangeCardAndDetails => {
  const { make, model, year, bodyStyle } = getCurrentData(diff);
  const title = `Vehicle ${changeTypes[diff.type]}`;
  const value = joinNonEmpty(year, make, model, bodyStyle);

  return {
    card: ({ 'data-testid': dataTestId, selected, onClick }) => (
      <PolicyChangeCard
        data-testid={dataTestId}
        title={title}
        onClick={onClick}
        selected={selected}
        type="vehicle"
        action={diff.type}
        value={value}
      />
    ),
    details: () => (
      <PolicyChangeVehicleDetails diff={diff} versionId={versionId} />
    ),
    metadata: {
      type: 'vehicle',
      action: diff.type,
      title,
      value,
    },
  };
};
